import { useState } from 'react';
import { Form, Button, PageHeader } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';

import { commonVerticalLayout } from '../../../constants/formLayout';
import { apiService, notificationService } from '../../../services';
import { Spinner } from '../../../components/Spinner';
import { Pages } from '../../../1_shared/constants/pages';
import { TypeTabs } from '../../../components/Tabs/TypeTabs';
import { dictionaries } from '../../../dictionaries';
import { useFetchData } from '../../../hooks/useFetchData';
import { ACL } from '../../../components/ACL';
import { Permissions } from '../../../enums/permissions';

export const TypeEditPage = () => {
  const navigate = useNavigate();
  const param: any = useParams();
  const [form] = Form.useForm();

  const { isLoading: isDataLoading, data = {} } = useFetchData(`/product-types/${param.id}`);
  const [isSaveBtnDisabled, setSaveBtnDisabled]: any = useState(false);

  const isNew = !param.id;

  const subTitle = isNew ? 'Создание типа товара' : 'Редактирование типа товара';

  if (!isNew && isDataLoading) {
    return <Spinner />;
  }

  const handleCancel = () => {
    navigate(Pages.TYPES);
  };

  const handleSave = async () => {
    try {
      setSaveBtnDisabled(true);

      await form.validateFields();
      const body = form.getFieldsValue();

      if (isNew) {
        const requestedData = await apiService.POST('/product-types', body);

        navigate(`${Pages.TYPES}/${requestedData.id}`);
      } else {
        await apiService.PATCH(`/product-types/${data.id}`, body);
      }
      notificationService.notifySuccess('Тип товара успешно сохранен');
      dictionaries.protuctTypesDictionary.fetch();
    } catch (error) {
      notificationService.notifyError(error);
    } finally {
      setSaveBtnDisabled(false);
    }
  };

  return (
    <ACL roles={[Permissions.SUPER_ADMIN, Permissions.ADMIN]}>
      <>
        <PageHeader
          className="page-header"
          title="Тип"
          subTitle={subTitle}
          extra={[
            <Button key="2" onClick={handleCancel}>
              {isNew ? 'Отмена' : 'Закрыть'}
            </Button>,
            <Button
              key="1"
              type="primary"
              disabled={isSaveBtnDisabled}
              onClick={handleSave}
            >
              Сохранить
            </Button>,
          ]}
        />
        <div className='page-content'>
          <Form
            className="mg-t-16"
            form={form}
            labelAlign="left"
            requiredMark={false}
            initialValues={data}
            layout="vertical"
            {...commonVerticalLayout}
          >
            <TypeTabs generalTabProps={{ data, form }} />
          </Form>
        </div>
      </>
    </ACL>
  );
};
